import { useLocale } from '@dreamstack/i18n'

const ComingSoonBaseUrls = {
  de: '/comingsoon',
  en: '/comingsoon',
}

export const useComingSoonBaseUrl = () => {
  const locale = useLocale()
  return ComingSoonBaseUrls[locale]
}
